import React from 'react';
import { team } from '../data/siteData';

import member1 from './assets/team/member1.png';
import member2 from './assets/team/member2.jpeg';
import member3 from './assets/team/member3.jpeg';
import member4 from './assets/team/member4.jpeg';
import member5 from './assets/team/member5.jpeg';
import member6 from './assets/team/member6.png';

const teamImages = [
  member1,
  member2,
  member3,
  member4,
  member5,
  member6,
];

function Team() {
  return (
    <section className="team-section" id="team">

      <div className="container">

        <div className="section-header">
          <p className="section-subtitle">Our Team</p>

          <h2 className="section-title">
            Meet The People Behind Our Success
          </h2>

          <p className="section-text">
            Our team includes developers, designers, leaders, and support
            specialists dedicated to delivering excellent software solutions.
          </p>
        </div>

        <div className="team-grid">

          {team.map((member, index) => {
            const Icon = member.icon;

            return (
              <div className="team-card" key={index}>

                {/* IMAGE */}
                <img
                  src={teamImages[index]}
                  alt={member.name}
                  className="team-image"
                />

                {/* OVERLAY DETAILS */}
                <div className="overlay">

                  {/* ICON */}
                  <div className="icon-box">
                    <Icon />
                  </div>

                  {/* DETAILS */}
                  <div className="overlay-content">
                    <h3>{member.name}</h3>

                    <span>{member.role}</span>

                    <p>{member.description}</p>
                  </div>

                </div>

              </div>
            );
          })}

        </div>

      </div>

    </section>
  );
}

export default Team;